<template>
  <v-container fluid>
    
    <v-row class="mb-4">
      <v-col cols="4" class="d-flex align-center">
       
      </v-col>
      <v-col cols="8" class="d-flex align-center justify-end">
      
        <template v-if="selected.length">
          <v-btn
            @click="removeSelected"
            depressed
            color="red lighten-5"
            class="red--text mr-2"
          >
            <span class="font-size-16 font-weight-600">
              <v-icon left color="red darken-2">mdi-account-remove</v-icon>
              Remove Selected
            </span>
          </v-btn>
          <v-btn
            @click="moveDriverDialog = true"
            depressed
            color="orange darken-2"
            class="white--text"
          >
            <span class="font-size-16 font-weight-600">
              <v-icon left>mdi-swap-horizontal</v-icon>
              Move to Zone
            </span>
          </v-btn>
        </template>
        <template v-else>
          <v-btn
            @click="openDriverDialog"
            depressed
            color="blue darken-2"
            class="white--text"
          >
            <span class="font-size-16 font-weight-600">
              <v-icon left>mdi-account-plus</v-icon>
              Assign Technician
            </span>
          </v-btn>
        </template>
      </v-col>
    </v-row>


    <perfect-scrollbar
      :options="{ suppressScrollX: true }"
      class="scroll custom-box-top-inner-shado"
      style="height: calc(100vh - 250px); position: relative"
    >
    
      <v-row v-if="drivers.length">
        <v-col

          class="pt-0"
          cols="12"
          sm="6"
          md="4"
          v-for="(driver, i) in drivers"
          :key="i"
        >
          <v-card outlined class="pa-5 rounded-lg">
          
            <div class="d-flex justify-space-between align-center mb-2">
              <div class="d-flex align-center">
                <v-checkbox
                  v-model="selected"
                  :value="driver.id"
                  class="mr-2"
                  hide-details
                ></v-checkbox>
                <v-avatar
                  size="40"
                  class="white--text font-weight-bold"
                  :color="getRandomColor()"
                >
                  {{ getInitials(driver.display_name) }}
                </v-avatar>
                <div class="ml-3">
                  <div class="font-weight-600">{{ driver.display_name }}</div>
                  <div class="grey--text text--darken-1 text-caption-1">
                    ID: {{ driver.barcode }}
                  </div>
                </div>
              </div>
              <v-chip
                small
                :color="
                  driver.activated == 1
                    ? 'green lighten-5'
                    : 'yellow lighten-5'
                "
                :text-color="
                  driver.activated == 1
                    ? 'green darken-2'
                    : 'orange darken-2'
                "
                class="font-weight-500 px-3"
                style="height: 24px"
              >
                {{ driver.activated == 1 ? 'Active' : 'Inactive' }}
              </v-chip>
            </div>

            <div class="mt-3">
              <p class="mb-1">
                <v-icon small color="grey darken-2" class="mr-2"
                  >mdi-phone</v-icon
                >
                Phone:{{ driver.primary_phone }}
              </p>
              <p class="mb-1">
                <v-icon small color="grey darken-2" class="mr-2"
                  >mdi-email</v-icon
                >
                Email: {{ driver.email }}
              </p>
              <p class="mb-1">
                <v-icon small color="grey darken-2" class="mr-2"
                  >mdi-calendar</v-icon
                >
                Assigned: {{ driver.assigned_date }}
              </p>
            </div>

            <div class="d-flex justify-space-between mt-4">
              <v-btn
                @click="routeToEngineer(driver.id)"
                outlined
                small
                class="custom-grey-border custom-bold-button flex-grow-1 text-center mr-2"
              >
                <span class="font-size-16 font-weight-600">
                  <v-icon left small>mdi-eye</v-icon> View
                </span>
              </v-btn>
              <v-btn
                @click="routeToUpdateCustomer(driver.id)"
                depressed
                small
                color="blue darken-2"
                class="white--text text-center flex-grow-1"
              >
                <span class="font-size-16 font-weight-600">
                  <v-icon left small>mdi-pencil</v-icon> Edit
                </span>
              </v-btn>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <div
        v-else
        class="d-flex flex-column align-center justify-center text-center"
        style="height: 300px"
      >
      <v-icon size="70" color="grey lighten-1">
        mdi-account-off-outline
      </v-icon>

    <div class="text-h6 text--darken-1 mt-3">
        No Technician Assigned
    </div>

    <div class="mt-1">
      This zone does not have any technicians assigned yet.
    </div>

  </div>


    </perfect-scrollbar>
    <!-- Assign Driver to Zone -->
    <Dialog :commonDialog="assignDriverDialog" :dialog-width="600" :key="zoneID">
      <template v-slot:title> Assign Technician to Zone </template>
      <template v-slot:body>
        <v-container fluid>
          <!-- Search -->
          <v-text-field
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            placeholder="Search available technicians..."
            dense
            outlined
            hide-details
            solo
            flat
            class="mb-3"
          ></v-text-field>
          <v-row>
            <v-col cols="12" v-for="(driver, i) in filteredDrivers" :key="i">
              <v-card
                outlined
                class="pa-3 d-flex align-center justify-space-between rounded-lg"
                elevation="0"
              >
                <!-- Left side -->
                <div class="d-flex align-center">
                  <!-- Checkbox -->
                  <v-checkbox
                    v-model="selectedDrivers"
                    :value="driver.id"
                    hide-details
                    class="mr-2"
                  ></v-checkbox>

                  <!-- Avatar -->
                  <v-avatar
                    size="40"
                    class="white--text font-weight-bold"
                    :color="getRandomColor()"
                  >
                     {{ getInitials(driver.display_name) }} 
                  </v-avatar>

                  <!-- Name + ID -->
                  <div class="ml-3">
                    <div class="font-weight-600 font-size-15">
                      {{ driver.display_name }}
                    </div>
                    <div class="grey--text text--darken-1 text-caption-1">
                      ID: {{ driver.barcode }}
                      <!-- {{ driver.status }} -->
                    </div>
                  </div>
                </div>

                <!-- Right side -->
                <div class="text-left">
                  <div class="font-weight-500">Phone:{{ driver.primary_phone }}</div>
                  <div class="font-weight-500">
                    Email: {{ driver.email }}
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </template>
      <template v-slot:action>
        <v-btn
          depressed
          class="mx-2 custom-grey-border custom-bold-button"
          v-on:click="assignDriverDialog = false;selectedDrivers=[];"
        >
          Close
        </v-btn>
        <v-btn
          :disabled="selectedDrivers <= 0"
          depressed
          class="mx-2 custom-grey-border custom-bold-button"
          color="cyan white--text"
          v-on:click="assignSelectedDrivers"
        >
          Assign Selected Technicians
        </v-btn>
      </template>
    </Dialog>
    <!-- Move Drivers to Zone -->
    <Dialog :commonDialog="moveDriverDialog" :dialog-width="600" :key="zoneID">
      <template v-slot:title> Move Technician to Zone </template>
      <template v-slot:body>
        <v-container fluid>
          <v-row>
            <v-col md="12">
              <label class="my-auto fw-500 mb-1">Move to Zone</label>
              <v-autocomplete
                hide-details
                v-model.trim="zone"
                :items="filteredZoneList"
                dense
                flat
                filled
                item-color="cyan"
                color="cyan"
                solo
                item-value="id"
                item-text="name"
                placeholder="Select Zone"
              />
            </v-col>
            <v-col md="12">
              <v-card
                color="grey lighten-4"
                elevation="0"
                class="pa-4 rounded-lg"
              >
                <span class="font-weight-500 pb-2 d-block" v-if="selected && selected.length > 0">
                  <strong>{{selected.length}} technician</strong> selected for moving
                </span>

                <!-- <div
                  v-if="selected.length"
                  class="grey--text text--darken-1"
                >
                  <div v-for="(driver, i) in selected" :key="driver.id">
                    • {{ driver.display_name }} ({{ driver.barcode }})<span
                      v-if="i < selected.length - 1"
                    >
                    </span>
                  </div>
                </div> -->
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </template>
      <template v-slot:action>
        <v-btn
          depressed
          class="mx-2 custom-grey-border custom-bold-button"
          v-on:click="moveDriverDialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :disabled="!zone"
          depressed
          class="mx-2 custom-grey-border custom-bold-button"
          color="cyan white--text"
          v-on:click="moveTechnician"
        >
          Move Technician
        </v-btn>
      </template>
    </Dialog>
  </v-container>
</template>

<script>
import Dialog from "@/view/pages/partials/Dialog.vue";
import {GET, POST} from "@/core/services/store/request.module";
export default {
  data() {
    return {
      zone: null,
      zoneId : 0,
      zoneList: [],
      assignDriverDialog: false,
      moveDriverDialog: false,
      search: "",
      statusFilter: "All Status",
      statusOptions: ["All Status", "Active", "On Leave"],
      selected: [],
      selectedDrivers : [],
      drivers : [],
      unAssignedDrivers : [],

    };
  },
  methods: {

    getRandomColor() {
      const colors = [
        "red",
        "pink",
        "purple",
        "deep-purple",
        "indigo",
        "blue",
        "light-blue",
        "cyan",
        "teal",
        "green",
        "light-green",
        "lime",
        "amber",
        "orange",
        "deep-orange",
      ];

      const randomIndex = Math.floor(Math.random() * colors.length);

      return colors[randomIndex];

    },

    async moveTechnician() {

     
      const payload = {
          zone_id: this.zone,
          technicians: this.selected,
      };

      this.$store.dispatch(POST, {
          url: "move-technician-to-zone/" + this.zoneID,
          data: payload
       
        }).then(() => {

         this.zone = null;
         this.selected = [];
         this.moveDriverDialog = false;
         this.$emit('refreshZones');
         this.getDrivers(this.zoneID);
        

      }).catch((error) => {
        this.logError(error);
      })
  },

    async openDriverDialog()
    {
        this.selectedDrivers = [];
        await this.getUnAssignedDrivers(this.zoneID);
        this.assignDriverDialog = true;
      
    },

    assignSelectedDrivers()
    {
        this.$store.dispatch(POST, {
          url: "assign-drivers-to-zone/" + this.zoneID,
          data:
        {
          driverIDs: this.selectedDrivers,
        }
        }).then(() => {

         this.selectedDrivers = [];
         this.assignDriverDialog = false;
         this.$emit('refreshZones');
         this.getDrivers(this.zoneID);
        


      }).catch((error) => {
        this.logError(error);
      })

    },

     getUnAssignedDrivers(id) {

      const _this = this;

      _this.$store.dispatch(GET, {
        url: "get-unassigned-drivers/" + id,
      }).then((response) => {

        this.unAssignedDrivers = response.data;
        
        
      }).catch((error) => {

        _this.logError(error);

      })
      
    },

     routeToEngineer(id) {

      this.$router.push({
        name: "admin.engineer.detail",
        params: { id },
      });
      
    },

    routeToUpdateCustomer(id)
    {

       this.$router.push({
        name: "admin.engineer.update",
        params: { id },
      });

    },

    getInitials(name) {
      
      return name
        .split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase();
    },

     getDrivers(id) {

      const _this = this;

      _this.$store.dispatch(GET, {
        url: "get-drivers/" + id,
      }).then((response) => {

        this.drivers = response.data;
        this.selected = [];
        this.selectedDrivers = [];
       
      }).catch((error) => {

        _this.logError(error);

      })
      
    },

    getServiceSetting() {
      const _this = this;
      _this.$store
        .dispatch(GET, { url: "setting/zones" })
        .then(({ data }) => {
          if (Array.isArray(data.zones)) {
            _this.zoneList = data?.zones;
          }
         
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },

    removeSelected() {
      this.selected = [];
    },

  },

  computed: {
    filteredDrivers() {
      if (!this.search) {
        return this.unAssignedDrivers;
      }
      const searchTerm = this.search.toLowerCase();

      return this.unAssignedDrivers.filter(driver => {
        return (
          driver.display_name?.toLowerCase().includes(searchTerm) ||
          driver.email?.toLowerCase().includes(searchTerm) ||
          driver.primary_phone?.toLowerCase().includes(searchTerm) ||
          driver.barcode?.toLowerCase().includes(searchTerm)
        );
      });
    },

    filteredZoneList() {

      return this.zoneList.filter(
      zone => String(zone.id) !== String(this.zoneID)
    );
  }
  },

   mounted() {

    this.zoneID = this.$route.params.id;
    this.getDrivers(this.zoneID);
    this.getServiceSetting();
    
  },

   watch: {
      '$route.params.id'(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          this.zoneID = newVal;
          this.getDrivers(newVal);
        }
      },
  },

  components: {
    Dialog,
  },
};
</script>

<style scoped>
.v-card {
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}
</style>
